import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiSearch,
  FiRepeat,
  FiPackage,
  FiShuffle,
  FiTag,
  FiSettings,
  FiActivity,
} from 'react-icons/fi';
import { useStore } from '../../context/StoreContext';

const actions = [
  { title: 'Label Printing', path: '/labels', description: 'Print shelf / promo labels', icon: FiTag },
  { title: 'Stock Lookup', path: '/lookup', description: 'Scan or search for live stock', icon: FiSearch },
  { title: 'Cycle Count', path: '/cycle-count', description: 'Record physical counts', icon: FiRepeat },
  { title: 'Goods Receiving', path: '/receiving', description: 'Receive POs on the floor', icon: FiPackage },
  { title: 'Stock Transfer', path: '/transfers', description: 'Transfer between stores', icon: FiShuffle },
  { title: 'Settings', path: '/settings', description: 'Printer + handheld preferences', icon: FiSettings },
];

const HandheldDashboard = () => {
  const { activeStore } = useStore();

  return (
    <div className="p-4 space-y-4">
      <div className="bg-white rounded-2xl shadow p-4">
        <p className="text-xs uppercase tracking-[0.4em] text-slate-400">Store</p>
        <h2 className="text-2xl font-semibold text-slate-900">{activeStore?.name || 'Select a store'}</h2>
        <p className="text-sm text-slate-500">
          Manage front-of-house inventory tasks directly from the TC60 handheld.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {actions.map(({ title, path, description, icon: Icon }) => (
          <Link
            to={path}
            key={path}
            className="bg-white rounded-2xl shadow p-4 flex items-center space-x-4 hover:ring-2 hover:ring-amber-300 transition"
          >
            <div className="bg-amber-100 text-amber-600 p-3 rounded-2xl">
              <Icon className="text-2xl" />
            </div>
            <div>
              <p className="text-lg font-semibold text-slate-900">{title}</p>
              <p className="text-sm text-slate-500">{description}</p>
            </div>
          </Link>
        ))}
      </div>

      <div className="bg-slate-900 text-white rounded-2xl p-4 flex items-start gap-3">
        <FiActivity className="text-3xl text-amber-400" />
        <div>
          <p className="text-sm uppercase tracking-[0.4em] text-amber-200">Shift tips</p>
          <p className="text-base">
            Remember to sync cycle counts before leaving the store floor to keep HQ reporting accurate.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HandheldDashboard;
